var _excluded = ["borderLeftWidth", "borderBottomWidth", "borderTopWidth", "borderRightWidth", "borderWidth", "borderStyle", "borderColor"],
  _excluded2 = ["className", "orientation", "__css"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef, omitThemingProps, useStyleConfig } from '../../system';
import { cx, __DEV__ } from '../../utils';
import * as React from 'react';

/**
 * Layout component used to visually separate content in a list or group.
 * It display a thin horizontal or vertical line, and renders a `hr` tag.
 */
export var Divider = forwardRef((props, ref) => {
  var _useStyleConfig = useStyleConfig('Divider', props),
    {
      borderLeftWidth,
      borderBottomWidth,
      borderTopWidth,
      borderRightWidth,
      borderWidth,
      borderStyle,
      borderColor
    } = _useStyleConfig,
    styles = _objectWithoutProperties(_useStyleConfig, _excluded);
  var _omitThemingProps = omitThemingProps(props),
    {
      className,
      orientation = 'horizontal',
      __css
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded2);
  var overrideBorderWidth = (props === null || props === void 0 ? void 0 : props.colorScheme) === 'gradient' ? '0' : borderWidth;
  var overrideDepth = (props === null || props === void 0 ? void 0 : props.colorScheme) === 'gradient' ? '1px' : '0';
  var dividerStyles = {
    vertical: {
      borderLeftWidth: borderLeftWidth || borderRightWidth || overrideBorderWidth || '1px',
      height: '100%',
      width: overrideDepth
    },
    horizontal: {
      borderBottomWidth: borderBottomWidth || borderTopWidth || overrideBorderWidth || '1px',
      width: '100%',
      height: overrideDepth
    }
  };
  return /*#__PURE__*/React.createElement(tqc.hr, _extends({
    ref: ref,
    role: "separator",
    "aria-orientation": orientation
  }, rest, {
    __css: _objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
      border: '0',
      borderColor,
      borderStyle
    }, dividerStyles[orientation]), __css),
    className: cx('tqc-divider', className)
  }));
});
if (__DEV__) {
  Divider.displayName = 'Divider';
}